import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "hero-content"
};
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#fff",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const _hoisted_4 = {
  class: "hero-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_b_container = _resolveComponent("b-container");
  return $data.networkInfo ? (_openBlock(), _createElementBlock("section", {
    key: 0,
    class: _normalizeClass(["hero", {
      'hero-logged-in': $props.loggedIn,
      'hero-public': !$props.loggedIn
    }]),
    style: _normalizeStyle($options.headerImageStyle)
  }, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "hero-overlay"
  }, null, -1)), _createVNode(_component_b_container, {
    class: "hero-content-wrap",
    fluid: $props.loggedIn
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
      class: _normalizeClass(["hero-logo", {
        'has-image': !!$options.profileImageUrl
      }])
    }, [$options.profileImageUrl ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: $options.profileImageUrl,
      alt: $data.networkInfo.name
    }, null, 8, _hoisted_2)) : (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[0] || (_cache[0] = [_createElementVNode("polygon", {
      points: "23 7 16 12 23 17 23 7"
    }, null, -1), _createElementVNode("rect", {
      x: "1",
      y: "5",
      width: "15",
      height: "14",
      rx: "2",
      ry: "2"
    }, null, -1)]))]))], 2), _createElementVNode("div", _hoisted_4, [_createElementVNode("h1", null, _toDisplayString($data.networkInfo.name), 1), !$props.loggedIn ? (_openBlock(), _createBlock(_component_router_link, {
      key: 0,
      to: "/subscribe/",
      class: "btn-hero-cta"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" Subscribe Now ", -1), _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, [_createElementVNode("line", {
        x1: "5",
        y1: "12",
        x2: "19",
        y2: "12"
      }), _createElementVNode("polyline", {
        points: "12 5 19 12 12 19"
      })], -1)]))], undefined, true),
      _: 1
    })) : _createCommentVNode("", true)])])], undefined, true),
    _: 1
  }, 8, ["fluid"])], 6)) : _createCommentVNode("", true);
}